module.exports = __webpack_public_path__ + "static/img/a042.5a9798e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/s/a042.jpg
// module id = DFdF
// module chunks = 0